import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=7fa56a88&scoped=true&"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=7fa56a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa56a88",
  null
  
)

export default component.exports